import subscriptionConfigReducer from "./SubscriptionsAdmin/subscriptionConfigSlice";
import { combineReducers } from "@reduxjs/toolkit";
import suppliersSlice from "./suppliers/slice";
import serviceSlice from "./services/slice";
import Categorylice from "./categories/slice";
import ProductSlice from "./products/slice";
import ClientSlice from "./clients/slice";
import BrandSlice from "./brands/slice";
import EmployeeSlice from "./employees/slice";
import PurchaseSlice from "./purchases/slice";
import PaymentMethodSlice from "./paymentMethod/slice";
import PackageSlice from "./package/slice";
import CommentSlice from "./comment/slice";
import ExpenseSlice from "./expense/slice";
import BonusSlice from "./bonus/slice";
import StockSlice from "./stock/slice";
import RoleSlice from "./roles/slice";
import GroupSlice from "./groups/slice";
import ScheduleSlice from "./schedules/slice";
import notificationsScheduleSlice from "./notificationsSchedule/slice";
import notificationsBirthdaySlice from "./notificationsBirthday/slice";
import notificationsInactiveSlice from "./notificationsInactive/slice";
import scheduleRelationService from "./scheduleRelationService/slice";
import scheduleRelationProduct from "./scheduleRelationProduct/slice";
import registerReducer from "./register/slice";
import PlansSlice from "./plans/slice";
import ReportsSlice from "./reports/slice";
import addressSlice from "./address/slice";
import CashierSlice from "./cashier/slice";
import SalesSlice from "./sales/slice";
import DashboardSlice from "./dashboard/slice";
import DashboardFinancialSlice from "./dashboardFinancial/slice";
import ClientSubscriptionSlice from "./clientSubscriptions/slice";
import SubscriptionSlice from "./SubscriptionsAdmin/slice";
import ClientCardTokenSlice from "./ClientCardToken/slice";
import SettingsSlice from "./settings/slice";
import PermissionSlice from "./permissions/slice";
import FullCommissionSlice from "./fullCommission/slice";
import SubscriptionUsageSlice from "./subscriptionUsage/slice";
import AdvancePaymentSlice from "./advancePayment/slice";
import PlanSubscriptionSlice from "./planSubscription/slice";
import SubscriptionPayments from "./paymentSubscription/slice";
import ProfileSlice from "./profile";
import UserServiceCommissionSlice from "./userServiceCommission/slice";
import MyCommissionsSlice from "./myCommissions/slice";
import AdminDashboardSlice from "./adminDashboard/slice";
import EstablishmentsSlice from "./establishments/slice";
import EvolutionSlice from "./evolution/slice";
import TokensSlice from "./tokens/slice";
import AsaasAdminSlice from "./asaasAdmin/slice";
import AsaasPaymentsSlice from "./asaasPayments/slice";
import SubscriptionWalletSlice from "./subscriptionWallet/slice";
import SubscriptionsClient from "./Subscriptions/slice";
import AdminFinanceDashboardSlice from "./adminFinanceDashboard/slice";
import EstablishmentBillingReducer from "./establishmentBilling/slice";
import changePlanReducer from "./Subscriptions/changePlanSlice";
import filesReducer from "./files/slice";

const rootReducer = combineReducers({
  subscriptionConfig: subscriptionConfigReducer,
  suppliers: suppliersSlice,
  services: serviceSlice,
  categories: Categorylice,
  products: ProductSlice,
  clients: ClientSlice,
  brands: BrandSlice,
  employees: EmployeeSlice,
  purchases: PurchaseSlice,
  paymentMethods: PaymentMethodSlice,
  packages: PackageSlice,
  comments: CommentSlice,
  expenses: ExpenseSlice,
  bonus: BonusSlice,
  stock: StockSlice,
  roles: RoleSlice,
  clientGroups: GroupSlice,
  schedules: ScheduleSlice,
  notificationsSchedule: notificationsScheduleSlice,
  notificationsBirthday: notificationsBirthdaySlice,
  notificationsInactive: notificationsInactiveSlice,
  scheduleRelationService: scheduleRelationService,
  scheduleRelationProduct: scheduleRelationProduct,
  register: registerReducer,
  plans: PlansSlice,
  reports: ReportsSlice,
  address: addressSlice,
  cashier: CashierSlice,
  sales: SalesSlice,
  dashboard: DashboardSlice,
  dashboardFinancial: DashboardFinancialSlice,
  clientSubscription: ClientSubscriptionSlice,
  subscription: SubscriptionSlice,
  clientCardToken: ClientCardTokenSlice,
  settings: SettingsSlice,
  premissions: PermissionSlice,
  fullCommission: FullCommissionSlice,
  advancePayment: AdvancePaymentSlice,
  planSubscription: PlanSubscriptionSlice,
  subscriptionPayments: SubscriptionPayments,
  profile: ProfileSlice,
  userServiceCommission: UserServiceCommissionSlice,
  myCommissions: MyCommissionsSlice,
  adminDashboard: AdminDashboardSlice,
  establishments: EstablishmentsSlice,
  evolution: EvolutionSlice,
  tokens: TokensSlice,
  asaasAdmin: AsaasAdminSlice,
  asaasPayments: AsaasPaymentsSlice,
  subscriptionWallet: SubscriptionWalletSlice,
  subscriptionUsage: SubscriptionUsageSlice,
  subscriptionsClient: SubscriptionsClient,
  adminFinanceDashboard: AdminFinanceDashboardSlice,
  establishmentBilling: EstablishmentBillingReducer,
  changePlan: changePlanReducer,
  files: filesReducer,
});

export default rootReducer;
